import * as Actions from '../actions';
import { QuestionAction } from '../actions';

export const initialState = {
    isUserAuthenticated: false,
    ShareType: '',
    ShareRenameID: '',
    isConnected: {},
    Profile: {},
    cartLength: 0
}
const questionReducer = (state = initialState, action: QuestionAction): typeof initialState => {
    switch (action.type) {
        case Actions.AUTH:
            return {
                ...state,
                isUserAuthenticated: 'isUserAuthenticated' in action && action.isUserAuthenticated
            }
        case Actions.SHARETYPE:
            return {
                ...state,
                ShareType: 'share' in action ? action.share : ""
            }
        case Actions.ITEMLENGTH:
            return {
                ...state,
                cartLength: 'len' in action ? action.len : 0
            }
        case Actions.SHARERENAMEID:
            return {
                ...state,
                ShareRenameID: 'id' in action ? action.id : ""
            }
        case Actions.USERPROFILE:


            return {
                ...state,
                Profile: 'user' in action && action.user
            }
        case Actions.CONNECTED:
            if ('connected' in action)
                return {
                    ...state,
                    isConnected: { ...state.isConnected, ...action.connected }
                }
            else
                return state
        default: // need this for default case
            return state
    }
}
export default questionReducer;